import { useEffect } from 'react';
import { dialogs } from '../dialogs/dialogStore';

interface Props {
  /** Für die Überschrift, z. B. „Bericht" */
  label: string;
  error: string | null;
  clearError: () => void;
  issues: string[];
  clearIssues: () => void;
}

/**
 * Zeigt Speicherfehler und Pflichtfeld-Mängel einer Bearbeitungs-Sitzung als Meldung —
 * nie als Text am Formularrand. Rendert nichts.
 *
 *   const s = useEditSession(…);
 *   <SaveFeedback label="Bericht" {...s} />
 */
export function SaveFeedback({ label, error, clearError, issues, clearIssues }: Props): null {
  useEffect(() => {
    if (!error) return;
    clearError();
    void dialogs.notify({ kind: 'error', title: `${label} wurde nicht gespeichert`, message: error });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (issues.length === 0) return;
    clearIssues();
    void dialogs.notify({ kind: 'error', title: `${label} kann nicht gespeichert werden`, message: 'Bitte zuerst ergänzen oder korrigieren:', items: issues });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issues]);

  return null;
}
